"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _clsx8 = _interopRequireDefault(require("clsx"));
var _head = _interopRequireDefault(require("next/head"));
var _useBannerTracking3 = _interopRequireDefault(require("../_utils/useBannerTracking"));
var _links = require("../_utils/links");
var _meta = require("../_utils/meta");
var _RichText = _interopRequireDefault(require("../RichText"));
var _Carousel = require("../Carousel/Carousel");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      position: 'relative',
      height: '400px',
      width: '100vw',
      left: '50%',
      right: '50%',
      marginLeft: '-50vw',
      marginRight: '-50vw',
      '.aem-ms-hero-leadership &': {
        height: '300px'
      }
    },
    bannerText: (0, _defineProperty2.default)({
      height: '100%',
      width: '100%',
      maxWidth: '720px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: theme.spacing(0),
      '&:hover': {
        textDecoration: 'none'
      }
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(0, 12)
    }),
    bannerText_homepage: (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
      margin: theme.spacing(0, 8)
    }),
    headline: {
      display: 'block',
      lineHeight: 1.2,
      fontWeight: theme.typography.fontWeightBold,
      paddingBottom: theme.spacing(1),
      color: theme.palette.common.white,
      '&$headline': (0, _defineProperty2.default)({
        marginTop: 0,
        marginBottom: theme.spacing(4),
        textDecoration: 'none',
        fontSize: theme.typography.pxToRem(32)
      }, theme.breakpoints.up('sm'), {
        fontSize: theme.typography.pxToRem(48)
      }),
      '&$headline:hover': {
        textDecoration: 'none'
      }
    },
    desc: (0, _defineProperty2.default)({
      fontSize: theme.typography.pxToRem(18),
      lineHeight: 1.45,
      fontWeight: theme.typography.fontWeightRegular,
      width: '100%',
      alignSelf: 'center',
      display: 'inline-block',
      color: theme.palette.common.white,
      '&$desc': {
        marginBottom: theme.spacing(0)
      },
      '& p': {
        display: 'inline-block',
        fontSize: theme.typography.pxToRem(24),
        lineHeight: 1.45
      }
    }, theme.breakpoints.up('sm'), {
      fontSize: theme.typography.pxToRem(24)
    }),
    descriptionColor: {
      color: theme.palette.common.white
    },
    leadershipDimensions: {
      height: '300px'
    },
    leadershipHeading: {
      fontSize: '32px !important',
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: 1.22,
      letterSpacing: '1.6px'
    },
    externalColorClassApplied: {
      color: 'inherit'
    },
    ctaLabel: {
      marginTop: theme.spacing(6),
      '& span': (0, _defineProperty2.default)({
        padding: theme.spacing(1),
        fontSize: theme.typography.pxToRem(18)
      }, theme.breakpoints.up('sm'), {
        padding: theme.spacing(0),
        fontSize: theme.typography.pxToRem(16)
      })
    },
    contentWidth: {
      width: '100%',
      maxWidth: 1440,
      margin: '0 auto'
    },
    baseAlignment: (0, _defineProperty2.default)({
      padding: theme.spacing(0, 6),
      justifyContent: 'flex-start'
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing(0, 10)
    }),
    rightAligned: (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), {
      textAlign: 'right',
      justifyContent: 'flex-end'
    }),
    centerAligned: (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), {
      padding: '0',
      textAlign: 'center',
      justifyContent: 'center'
    }),
    bgImage: {
      height: '400px',
      width: '100%',
      display: 'flex',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      maxWidth: '1440px',
      margin: '0 auto',
      '&$bgImage:hover': {
        textDecoration: 'none'
      },
      '.aem-ms-hero-leadership &': {
        height: '300px'
      }
    },
    homepageHeight: {
      height: '488px'
    }
  };
});
var Hero = function Hero(props) {
  var _clsx3, _clsx5, _clsx6, _clsx7;
  var image = props.image,
    heading = props.heading,
    subHeading = props.subHeading,
    textPosition = props.textPosition,
    url = props.url,
    ctaLabel = props.ctaLabel,
    description = props.description,
    cardType = props.cardType,
    _props$backgroundColo = props.backgroundColorCSS,
    backgroundColorCSS = _props$backgroundColo === void 0 ? '' : _props$backgroundColo,
    _props$themeColorCSS = props.themeColorCSS,
    themeColorCSS = _props$themeColorCSS === void 0 ? '' : _props$themeColorCSS,
    _props$headingColorCS = props.headingColorCSS,
    headingColorCSS = _props$headingColorCS === void 0 ? '' : _props$headingColorCS,
    _props$descriptionCol = props.descriptionColorCSS,
    descriptionColorCSS = _props$descriptionCol === void 0 ? '' : _props$descriptionCol,
    anchorId = props.anchorId,
    _props$promotionCreat = props.promotionCreative,
    promotionCreative = _props$promotionCreat === void 0 ? '' : _props$promotionCreat,
    _props$promotionId = props.promotionId,
    promotionId = _props$promotionId === void 0 ? '' : _props$promotionId,
    _props$promotionName = props.promotionName,
    promotionName = _props$promotionName === void 0 ? '' : _props$promotionName,
    h1Tag = props.h1Tag,
    disableOnPublisher = props.disableOnPublisher;
  var isEdit = (0, _meta.getWcmmode)() === 'edit';
  var linkProps = url && (0, _links.getTarget)(url);
  var imageData = image !== null && image !== void 0 ? image : {};
  var isHomepageHero = cardType === 'homepage';
  var isLeadershipVariation = cardType === 'leadership';
  var classes = useStyles();
  var _useBannerTracking = (0, _useBannerTracking3.default)(undefined, isHomepageHero),
    _useBannerTracking2 = (0, _slicedToArray2.default)(_useBannerTracking, 2),
    trackBannerRedirectEventGA = _useBannerTracking2[1];
  var _useState = (0, _react.useState)(false),
    isFirstHeroImg = _useState[0],
    setIsFirstHeroImg = _useState[1];
  var imageClasses = (0, _defineProperty2.default)({}, classes.homepageHeight, isHomepageHero);
  var activeSlide = (0, _react.useContext)(_Carousel.CarouselContext);
  var descriptionColorClass = descriptionColorCSS !== null && descriptionColorCSS !== void 0 ? descriptionColorCSS : '';
  var themeColorClass = themeColorCSS !== null && themeColorCSS !== void 0 ? themeColorCSS : '';
  var headingColorClass = headingColorCSS !== null && headingColorCSS !== void 0 ? headingColorCSS : '';
  var backgroundColorClass = backgroundColorCSS !== null && backgroundColorCSS !== void 0 ? backgroundColorCSS : '';
  (0, _react.useEffect)(function () {
    if (isHomepageHero && !window.hasHeroPreloaded) {
      setIsFirstHeroImg(true);
      window.hasHeroPreloaded = true;
    }
  }, [imageData.src, isHomepageHero]);
  var heroContents = __jsx("div", {
    className: (0, _clsx8.default)(classes.bannerText, (0, _defineProperty2.default)({}, classes.bannerText_homepage, isHomepageHero))
  }, subHeading && __jsx("div", {
    className: themeColorClass
  }, __jsx(_core.Typography, {
    className: (0, _clsx8.default)(classes.desc, (0, _defineProperty2.default)({}, classes.externalColorClassApplied, themeColorClass))
  }, __jsx(_RichText.default, {
    text: subHeading
  }))), heading && __jsx("div", {
    className: headingColorClass
  }, __jsx(_core.Typography, {
    component: !isLeadershipVariation && h1Tag ? 'h1' : 'p',
    className: (0, _clsx8.default)(classes.headline, (_clsx3 = {}, (0, _defineProperty2.default)(_clsx3, classes.externalColorClassApplied, headingColorClass), (0, _defineProperty2.default)(_clsx3, classes.leadershipHeading, isLeadershipVariation), _clsx3)),
    dangerouslySetInnerHTML: {
      __html: heading
    }
  })), description && __jsx("div", {
    className: descriptionColorClass
  }, __jsx(_core.Typography, {
    className: (0, _clsx8.default)(classes.desc, (0, _defineProperty2.default)({}, classes.externalColorClassApplied, descriptionColorClass)),
    dangerouslySetInnerHTML: {
      __html: description
    }
  })), ctaLabel && __jsx("div", {
    className: (0, _clsx8.default)(classes.ctaLabel)
  }, !url ? ctaLabel : __jsx(_core.Button, {
    variant: "contained",
    color: "primary"
  }, ctaLabel)));
  if (!isEdit && disableOnPublisher) {
    return null;
  }
  return __jsx(_react.default.Fragment, null, isFirstHeroImg && __jsx(_head.default, null, __jsx("link", {
    rel: "preload",
    href: imageData.src,
    as: "image"
  })), __jsx("div", {
    id: anchorId,
    className: (0, _clsx8.default)(classes.wrapper, (_clsx5 = {
      'aem-ms-hero-leadership': isLeadershipVariation,
      'aem-ms-hero-homepage': isHomepageHero
    }, (0, _defineProperty2.default)(_clsx5, classes.homepageHeight, isHomepageHero), (0, _defineProperty2.default)(_clsx5, classes.leadershipDimensions, isLeadershipVariation), _clsx5))
  }, __jsx("div", {
    className: classes.contentWidth
  }, !url ? __jsx("div", {
    style: imageData.src ? {
      backgroundImage: "url(".concat(imageData.src, ")")
    } : {},
    className: (0, _clsx8.default)(classes.bgImage, imageClasses, backgroundColorClass, classes.baseAlignment, (_clsx6 = {}, (0, _defineProperty2.default)(_clsx6, classes.rightAligned, textPosition === 'right'), (0, _defineProperty2.default)(_clsx6, classes.centerAligned, textPosition === 'center'), _clsx6)),
    "aria-label": imageData && imageData.alt
  }, heroContents) : __jsx("a", (0, _extends2.default)({
    href: url,
    style: imageData.src ? {
      backgroundImage: "url(".concat(imageData.src, ")")
    } : {},
    className: (0, _clsx8.default)(classes.bgImage, imageClasses, backgroundColorClass, classes.baseAlignment, (_clsx7 = {}, (0, _defineProperty2.default)(_clsx7, classes.rightAligned, textPosition === 'right'), (0, _defineProperty2.default)(_clsx7, classes.centerAligned, textPosition === 'center'), _clsx7)),
    title: imageData && imageData.title,
    color: "primary"
  }, linkProps, {
    // @ts-ignore - custom html attribute
    ga_product: "".concat(promotionId, "|").concat(promotionName, "|").concat(promotionCreative),
    onClick: function onClick(e) {
      return trackBannerRedirectEventGA(e, activeSlide);
    },
    "aria-label": imageData && imageData.alt
  }), heroContents))));
};
var HeroEditConfig = {
  emptyLabel: 'Hero Component',
  isEmpty: function isEmpty(props) {
    if (props.url || props.textPosition) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/herocomponent')(Hero, HeroEditConfig);
exports.default = _default;